import { Body, FlexAction, Span, SubmitRow } from "./NewUsersStyle";
import {
  ButtonDefault,
  ButtonSecondary,
  SelectFieldInput,
  TextField,
  CheckBox
} from "components/shared/CustomInputs";
import React, { useEffect, useState, PureComponent } from "react";
import FormGroup from "../../../../components/Forms/group/FormGroup";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Col, Modal, Row } from "react-bootstrap";
import { required } from "../../../../helpers/validations";
import { Creators as managerActions } from "store/ducks/manager";
import { Creators as employeeAction } from "store/ducks/employee";
import { Creators as messageAction } from "store/ducks/messages";
import { FormattedMessage, injectIntl } from "react-intl";
import { Redirect } from "react-router-dom";
import {
  formatErrorsMessages
} from "../../../../helpers/sharedHelpers";

const NewUsers = ({
  getProfilesList,
  profilesData,
  getEmployee,
  employeeData,
  messagePublication,
  intl,
  users

}) => {

  const [formValues, setFormValues] = useState({
    registrationNumber: '',
    name: '',
    email: '',
    profile: '',
    pessoaId: 0,
    isAdministrador: false,
    canAcessPlug: false,
    canAcessTalentos: false
  });

  const [formErros, setFormErros] = useState([]);
  const [formValidators, setFormValidators] = useState();
  const [submited, setSubmited] = useState(false);
  const [profiles, setProfiles] = useState(new Array());
  const [employee, setEmployee] = useState({});
  const [foundEmployee, setFoundEmployee] = useState(false);

  useEffect(() => {
    getProfilesList();
    getEmployee('');
  }, []);

  useEffect(() => {
    setProfiles(profilesData["profiles"]);
  }, [profilesData, profiles]);

  useEffect(() => {
    setEmployee(employeeData["employee"]);
    if (!isEmpty(employee)) {
      setFoundEmployee(true);
      setFormValues({ ...formValues, name: employee.nome, email: employee.email, pessoaId: employee.pessoa.id });
    }
    else {
      setFoundEmployee(false);
      setFormValues({ ...formValues, name: '', email: '' });
    }
  }, [employeeData, employee]);

  function isEmpty(obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop))
        return false;
    }

    return true;
  }
  const renderSaveButtonTitle = () => {
    return <FormattedMessage id="sharedItems.save" />;
  };
  const renderSearchButtonTitle = () => {
    return <FormattedMessage id="manager.search" />;
  };

  const renderBodyTitle = () => {
    return <FormattedMessage id="manager.newUser" />;
  };
  const changeName = (name) => {
    if (formValues.name && formValues.name != name) {
      setFormValues({
        ...formValues,
        name: name,
        pessoaId: 0
      })
    }
    else {
      setFormValues({
        ...formValues,
        name: name
      })
    }
  }
  const save = () => {
    setSubmited(true);
    if (!Object.keys(formErros).length) {
      saveValidEmployee();
    } else {
      const formErrosMessages = formatErrorsMessages(formErros);
      messagePublication(formErrosMessages);
    }
  }
  const saveValidEmployee = () => {
    users(
      formValues
    );
  };
  const search = (term) => {
    getEmployee(term);
  }
  return (
    <React.Fragment>
      <Body>
        <FormGroup formName={renderBodyTitle()}>
          <Row>
            <Col
              md={4}>
              <TextField
                onChange={event =>
                  setFormValues({
                    ...formValues,
                    registrationNumber: event.target.value.replace(/[^0-9. ]/g, "")
                  })
                }
                setFormErros={setFormErros}
                formValidators={setFormValidators}
                touched={submited}
                formErr={formErros}
                name={intl.formatMessage({ id: "manager.registrationNumber" })}
                label={<FormattedMessage id="manager.registrationNumber" />}
                value={formValues.registrationNumber}
              />
            </Col>
            <Col style={{ marginTop: "15px" }}
              md={2}>
              <ButtonSecondary
                name={renderSearchButtonTitle()}
                onClick={() => {
                  search(formValues.registrationNumber);
                }}
                disabled={formValues.registrationNumber == ''}
              />
            </Col>
          </Row>
          <Row>
            <Col
              md={6}>
              <TextField
                onChange={event => changeName(event.target.value)}
                validations={[required]}
                setFormErros={setFormErros}
                formValidators={setFormValidators}
                touched={submited}
                formErr={formErros}
                name={intl.formatMessage({ id: "manager.name" })}
                label={<FormattedMessage id="manager.name" />}
                value={formValues.name}
              />
            </Col>
            <Col
              md={6}>
              <TextField
                onChange={event =>
                  setFormValues({
                    ...formValues,
                    email: event.target.value
                  })
                }
                validations={[required]}
                setFormErros={setFormErros}
                formValidators={setFormValidators}
                touched={submited}
                formErr={formErros}
                name={intl.formatMessage({ id: "manager.email" })}
                label={<FormattedMessage id="manager.email" />}
                value={formValues.email}
              />
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <SelectFieldInput
                label={<FormattedMessage id="manager.Perfil" />}
                items=
                {
                  profiles?.map(profiler =>
                  ({
                    name: profiler.nome,
                    id: profiler.id
                  }))
                }
                validations={[required]}
                setFormErros={setFormErros}
                formValidators={setFormValidators}
                touched={submited}
                formErr={formErros}
                name={intl.formatMessage({ id: "manager.Perfil" })}
                value={formValues.profile}
                onChange={event => {
                  setFormErros([]);
                  formValues.profile = event.target.value;
                }} />
            </Col>
            <Col md={3}>
              <CheckBox
                label={<FormattedMessage id="manager.IsAdministrator" />}
                checked={formValues.isAdministrador}
                onChange={() =>
                  setFormValues({
                    ...formValues,
                    isAdministrador: !formValues.isAdministrador
                  })
                }
              />
            </Col>
            <Col md={3}>
              <CheckBox
                label={<FormattedMessage id="manager.canAcessTalentos" />}
                checked={formValues.canAcessTalentos}
                onChange={() =>
                  setFormValues({
                    ...formValues,
                    canAcessTalentos: !formValues.canAcessTalentos
                  })
                }
              />
            </Col>
            <Col md={3}>
              <CheckBox
                label={<FormattedMessage id="manager.canAcessPlug" />}
                checked={formValues.canAcessPlug}
                onChange={() =>
                  setFormValues({
                    ...formValues,
                    canAcessPlug: !formValues.canAcessPlug
                  })
                }
              />
            </Col>
          </Row>
          <SubmitRow className="row">
            <div style={{ padding: "5px" }} className="col-lg-2">
              <FlexAction>
                <ButtonDefault
                  onClick={() => {
                    save();
                  }}
                  
                  name={renderSaveButtonTitle()}
                />
              </FlexAction>
            </div>
          </SubmitRow>
        </FormGroup>

      </Body>

    </React.Fragment>
  );
};

const mapStateToProps = state => ({
  profilesData: state.profiles,
  employeeData: state.employee
});

const mapDispatchToProps = dispatch => ({
  getProfilesList: payload => dispatch(managerActions.profilesRequest(payload)),
  getEmployee: registerNumber =>
    dispatch(employeeAction.employeeSearchRequest(registerNumber)),
  messagePublication: messages =>
    dispatch(messageAction.messagePublication(messages)),
  users: payload => dispatch(managerActions.usersRequest(payload)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(NewUsers));


